var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('billing-side-by-side',{attrs:{"left":_vm.left,"right":_vm.right}}),_vm._v(" "),_c('employer-notes-wrapper',{attrs:{"employer-id":_vm.employerId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }